import { render, staticRenderFns } from "./CowsEmbryoTransfterForm.vue?vue&type=template&id=38495fca&scoped=true&"
import script from "./CowsEmbryoTransfterForm.vue?vue&type=script&lang=js&"
export * from "./CowsEmbryoTransfterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38495fca",
  null
  
)

export default component.exports